<template>
  <footer v-if="!isAuthenticated" class="bg-[var(--deep-charcoal)] text-[var(--cream)] py-8 px-4 md:py-10 md:px-8">
    <div class="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6 md:gap-8">
      <div class="flex flex-col items-center md:items-start">
        <router-link to="/" class="group flex flex-col items-center md:items-start transition-all duration-300 mb-3">
          <div
            class="font-bold transition-all duration-300 group-hover:-translate-y-px group-hover:scale-[1.01] transform-gpu tracking-wide leading-tight relative z-10 text-xl md:text-2xl"
            style="
              font-family: 'Playfair Display', serif;
              background: linear-gradient(
                135deg,
                #d4af37 0%,
                #c7ae6a 25%,
                #d4af37 50%,
                #f4d03f 75%,
                #d4af37 100%
              );
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              background-clip: text;
              text-shadow: 0 0 30px rgba(212, 175, 55, 0.3);
            "
          >
            Amadeen Consult
          </div>
          <div
            class="font-normal tracking-wide mt-0.5 tagline relative z-10 text-xs md:text-sm"
            style="
              font-family: 'Caveat', cursive;
              color: rgba(212, 175, 55, 0.95);
              text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
            "
          >
            Stay. Live. Own.
          </div>
        </router-link>
        
        <p class="text-[11px] font-light leading-snug opacity-60 max-w-sm text-center md:text-left uppercase tracking-wider">Redefining the standard of luxury living through innovation, discretion, and world-class service.</p>
        
        <!-- <div class="flex gap-6">
          <a class="text-[var(--gold)] hover:text-white transition-colors" href="#"><span class="material-symbols-outlined text-2xl">share</span></a>
          <a class="text-[var(--gold)] hover:text-white transition-colors" href="#"><span class="material-symbols-outlined text-2xl">alternate_email</span></a>
          <a class="text-[var(--gold)] hover:text-white transition-colors" href="#"><span class="material-symbols-outlined text-2xl">call</span></a>
        </div> -->
      </div>
      
      <div class="text-center md:text-right flex flex-col items-center md:items-end gap-3">
        <nav v-if="!isBioOnly" class="flex flex-wrap justify-center md:justify-end gap-x-5 gap-y-1">
          <router-link to="/" class="text-[var(--gold)] hover:text-white uppercase transition-colors text-xs tracking-wide">Home</router-link>
          <router-link to="/listings" class="text-[var(--gold)] hover:text-white uppercase transition-colors text-xs tracking-wide">Properties</router-link>
          <router-link to="/list-with-us" class="text-[var(--gold)] hover:text-white uppercase transition-colors text-xs tracking-wide">List with us</router-link>
          <router-link to="/bio" class="text-[var(--gold)] hover:text-white uppercase transition-colors text-xs tracking-wide">Concierge</router-link>
        </nav>

        <div class="flex items-center gap-3 text-[10px] uppercase tracking-[0.35em] opacity-45">
          <button @click="toggleDarkMode" class="inline-flex items-center hover:text-white transition-colors" aria-label="Toggle theme">
            <span class="material-symbols-outlined text-base">{{ isDarkMode ? 'light_mode' : 'dark_mode' }}</span>
          </button>
          <span class="h-3 w-px bg-[var(--cream)]/20" aria-hidden="true"></span>
          <span class="normal-case tracking-normal leading-snug">
            &copy; {{ new Date().getFullYear() }} All rights reserved.
            <a href="https://sitati.vercel.app" target="_blank" rel="noopener noreferrer" class="hover:text-white transition-colors">Sitati</a>
          </span>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { isBioOnlyDomain } from "@/utils/siteMode";

export default {
  name: 'MainFooter',
  data() {
    return {
      isDarkMode: false
    };
  },
  mounted() {
    // Check for saved theme preference or system preference
    const savedTheme = localStorage.getItem('color-theme');
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    
    this.isDarkMode = savedTheme === 'dark' || (!savedTheme && prefersDark);
    
    // Apply theme to document
    this.applyTheme();
  },
  computed: {
    isBioOnly() {
      return isBioOnlyDomain();
    },
    isAuthenticated() {
      // Check if user is authenticated by checking for valid token
      const token = JSON.parse(window.localStorage.getItem("token"));
      if (!token) return false;
      
      // Check if token is not expired
      const today = new Date();
      const tokenExpiry = new Date(0);
      tokenExpiry.setUTCSeconds(token.expires);
      
      return tokenExpiry > today;
    }
  },
  methods: {
    toggleDarkMode() {
      this.isDarkMode = !this.isDarkMode;
      
      // Save preference
      localStorage.setItem('color-theme', this.isDarkMode ? 'dark' : 'light');
      
      // Apply theme
      this.applyTheme();
    },
    
    applyTheme() {
      if (this.isDarkMode) {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }
    },
    
    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }
};
</script>

<style scoped>
/* Import Google Fonts for consistency */
@import url("https://fonts.googleapis.com/css2?family=Caveat:wght@400;500&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;700&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600&display=swap");

/* Font classes */
.font-handwriting {
  font-family: "Caveat", cursive;
}

.font-serif {
  font-family: "Playfair Display", serif;
}

.font-sans {
  font-family: "Montserrat", sans-serif;
}
</style>
